import axios from '@/api/config';

const feedback = {
  getfeedback(data) {
    return axios.post(`${process.env.BASE_URL}/feedBack/pageList` , data);
  },
  getfeedbackdetailed(data) {
    return axios.get(`${process.env.BASE_URL}/feedBack/getFeedBack` ,  {params: data});
  },
  feedbackAnswer(data){
    return axios.post(`${process.env.BASE_URL}/feedBack/answerFeedBack` ,  data);
  },
  feedbackDelete(data){
    return axios.delete(`${process.env.BASE_URL}/feedBack/deleteFeedBack` , {data:data});
  },
  updateFeedBack(data){
    return axios.put(`${process.env.BASE_URL}/feedBack/updateFeedBack` , data);
  }
}
export default feedback;


// WEBPACK FOOTER //
// ./src/api/feedback.js